import React from "react";
import { IonLabel, IonText } from "@ionic/react";
import { Controller, FieldError } from "react-hook-form";
import { IControlData } from "../../models/Control";
import classNames from "classnames";
import InputError from "../utils/InputError";
import InputHint from "../utils/InputHint";
import PhoneInput from "react-phone-input-2";

interface IProps {
  name: string;
  label: string | null;
  error?: FieldError;
  hint?: string;
  controlData: IControlData;
}

const PhoneWrapper: React.FC<IProps> = ({ name, error, label, controlData, hint }) => {
  return (
    <div className={classNames("ion-stack vertical", error ? "error" : "")}>
      {label && (
        <IonLabel>
          {label}
          {controlData?.rules?.required?.value === true ? <IonText color="danger">*</IonText> : null}
        </IonLabel>
      )}
      <Controller
        name={name}
        render={({ field: { onChange, value } }) => (
          <PhoneInput regions={"europe"} country={"hu"} value={value} onChange={(phone) => onChange(phone)} inputProps={{ required: true }} placeholder="+36 00 12 34 567" masks={{ hu: ".. .. .. ..." }} />
        )}
        {...controlData}
      />
      {error ? <InputError>{error.message ?? ""}</InputError> : null}
      {hint ? <InputHint>{hint}</InputHint> : null}
    </div>
  );
};

export default PhoneWrapper;
